import styled from 'styled-components';

export const ModalSectionLayout = styled.div`
    padding-bottom: 32px;
`;

export const ModalSectionTitleLayout = styled.div`
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: space-between;

    owc-typography {
        color: #544f4f;
    }
`;

export const ModalSectionDescriptionLayout = styled.div`
    padding-bottom: 8px;

    owc-typography {
        color: #706b69;
    }
`;

export const ModalSectionChildrenLayout = styled.div``;
